module.exports = __webpack_public_path__ + "img/icon_5_57.05c3d152.png";